export const NetworkContextName = 'NETWORK'
export const connectorLocalStorageKey = 'connectorId'
